export function getAspectRatio(view) {
  if (view.type === 'scene') {
    return view.scene.dimensions.width / view.scene.dimensions.height;
  }
  return view.panel.aspectRatio;
}